import React, { Component } from 'react';
import { toast } from 'react-toastify';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';
import ReactGA from 'react-ga';
import HarmWatchFeed from './components/HarmWatchFeed';
import { 
  NUMBER_OF_COLUMNS_ON_HARM_WATCH_DASHBOARD,
  CHARGED_POSTS_BUTTON_LABEL,
  HEATED_COMMENTS_BUTTON_LABEL,
  TOXIC_COMMENTS_BUTTON_LABEL,
  EXPORT_BUTTON_LABEL,
  IMAGE_BTN_SELECTED_CLASS,
  IMAGE_BTN_UNSELECTED_CLASS,
  FEED_MODAL_PAGE_LIMIT,
  HEATED_COMMENTS_PERCENTAGE_THRESHOLD,
  TOXIC_COMMENTS_PERCENTAGE_THRESHOLD
} from './constants';
import { Button, ImageButton } from '../shared-components';
import * as actions from '../home/redux/actions';
import FeedDetails from '../home/components/feeds-detail-modal/Feeds-Detail-Modal';
import { RELEVANT_OPTION_VALUE } from '../home/components/comment-filter/constants/RelevanceFilterConstants';
import {
  ALL,
  ALL_SOURCES,
  DEFAULT_POST_SORT_TYPE_VALUE,
  GROUP_BY_SENTIMENT_STATE,
  GROUP_BY_EMOTION_STATE,
  MAXIMUM_DECIMAL_PLACES_FOR_SARCASM_SCORE,
  SORT_BY_DATE_NEW_TO_OLD_STATE,
  COMMENT_SORT_STATE_TO_VALUE_MAP,
  VALUE_KEY,
  COMMENT_SORT_OPTIONS,
  SARCASM_LABEL_UPDATED_MESSAGE,
  SARCASM_LABEL_NOT_UPDATED_MESSAGE,
  SARCASM_POST_COUNT_UPDATE_ERROR_MESSAGE
} from '../home/redux/constants';
import { DATA_KEY } from '../shared-components/chart/constants/eventLabellingChartConstants';
import { 
  TOXIC_COMMENTS_ICON_FILE_PATH,
  HEATED_COMMENTS_ICON_FILE_PATH,
  CHARGED_POST_ICON_FILE_PATH
} from './components/constants';
import { apiEndPoints, HARM_WATCH_FROM_DATE, HARM_WATCH_TO_DATE } from '../../common/globalConstants';
import http from '../../common/http';
import { getLoginRedirectUrl } from '../home/sharedFunctions';

const PAGE_LIMIT            = 200;
const FEED_MODAL_ITEM_COUNT = 10;
const COUNT                 = 'count';

export class HarmWatch extends Component {
  static propTypes = {
    home: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired
  };

  constructor(props) {
    super(props);
    this.state = {
      selectedTopicID: [],
      commentsFeedsFilterDate: {
        fromDate: HARM_WATCH_FROM_DATE,
        toDate: HARM_WATCH_TO_DATE,
      },
      currentFeedsPage: 1,
      isFeedsLoading: false,
      sentiments: [ALL],
      sources: [ALL_SOURCES],
      feeds: { data: [], count: null },
      trendingRangeInHours: 24,
      postSortType: DEFAULT_POST_SORT_TYPE_VALUE,
      relevanceFilterOption: RELEVANT_OPTION_VALUE,
      groupFeedModalCommentsBy: GROUP_BY_SENTIMENT_STATE,
      sortFeedModalCommentsBy: SORT_BY_DATE_NEW_TO_OLD_STATE,
      isFeedModal: false,
      activeFeedCategory: ALL,
      selectedFeedIndex: null,
      feedModalMinimumSarcasmScore: 0,
      feedModalMaximumSarcasmScore: 100,
      isChargedPostsFilterActive: false,
      isEmotionallyHeatedFilterActive: false,
      isToxicCommentsFilterActive: false,
      filteredFeeds: { data: [], count: null },
      emotionCategoriesBeforeTogglingComment: {},
      sentimentCategoriesBeforeTogglingComment: {},
      isManuallyTogglingSarcasm: false
    };
  }

  componentDidMount() {
    ReactGA.pageview('/harmwatch');

    const checkAuthTokenRequest = http.get(apiEndPoints.authentication.CHECK_TOKEN);
    checkAuthTokenRequest.then(
      response => {
        this.retrieveAllFeeds(this.state.selectedTopicID);
        this.setState({
          isChargedPostsFilterActive: false,
          isEmotionallyHeatedFilterActive: false,
          isToxicCommentsFilterActive: false
        });
      },
      error => {
        this.props.history.push(getLoginRedirectUrl());
        return false;
      },
    );
  }

  loadMoreFeeds = () => {
    this.setState(
      prevState => {
        return {
          currentFeedsPage: prevState.currentFeedsPage + 1,
          isFeedsLoading: true,
        };
      },
      () => {
        this.props.actions.retrieveAllFeeds({
          topicId: this.state.selectedTopicID,
          currentPage: this.state.currentFeedsPage,
          pageLimit: PAGE_LIMIT,
          fromDate: this.state.commentsFeedsFilterDate.fromDate,
          toDate: this.state.commentsFeedsFilterDate.toDate,
          sentiments: this.state.sentiments,
          sources: this.state.sources,
          sortType: this.state.postSortType,
          relevanceFilterOption: this.state.relevanceFilterOption,
          trendingRangeInHours: this.state.trendingRangeInHours
        });
      },
    );
  };

  static getDerivedStateFromProps(nextProps, prevState){
    let update = {};

    if (nextProps.home.activeTopic !== prevState.selectedTopicID) {
      update.selectedTopicID = nextProps.home.activeTopic;
    } 

    if (
      Object.keys(nextProps.home.allFeeds).length &&
      JSON.stringify(prevState.feeds) !== JSON.stringify(nextProps.home.allFeeds)
    ) {
      update.isFeedsLoading = false;
      update.feeds = nextProps.home.allFeeds;
    }

    return update;
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.selectedTopicID !== this.state.selectedTopicID) {
      this.retrieveAllFeeds(this.state.selectedTopicID);
    }
    this.updateStateIfIsSarcasmManuallyToggledUpdated(this.props);
  }

  retrieveAllFeeds (selectedTopicID) {
    const stateToSet = this.getStateForRetrievingAllFeeds(selectedTopicID);
    const { postSortType } = this.state;
    const postDataForFeeds = this.getPostDataForRetrievingAllFeeds(selectedTopicID, this.state.sentiments, postSortType);
    this.setState(stateToSet, () => {
      this.props.actions.retrieveAllFeeds(postDataForFeeds);
    });
  }

  getPostDataForRetrievingAllFeeds(selectedTopicID, sentiments, sortType){
    const resetCurrentPage = 1;
    return {
      topicId: selectedTopicID,
      currentPage: resetCurrentPage,
      sources: this.state.sources,
      sentiments: sentiments,
      fromDate: this.state.commentsFeedsFilterDate.fromDate,
      toDate: this.state.commentsFeedsFilterDate.toDate,
      sortType: sortType,
      pageLimit: PAGE_LIMIT,
      relevanceFilterOption: this.state.relevanceFilterOption,
      trendingRangeInHours: this.state.trendingRangeInHours
    };
  }

  getStateForRetrievingAllFeeds(selectedTopicID) {
    const resetCurrentPage = 1;
    return {
        selectedTopicID,
        currentFeedsPage: resetCurrentPage
    };
  }

  handleFeedDetails = (sentiment, index) => {
    const { sortFeedModalCommentsBy, feedModalMinimumSarcasmScore, feedModalMaximumSarcasmScore } = this.state;
    const minimumSarcasmScoreDecimal = this._parseSarcasmScorePercentageToDecimal(feedModalMinimumSarcasmScore);
    const maximumSarcasmScoreDecimal = this._parseSarcasmScorePercentageToDecimal(feedModalMaximumSarcasmScore);
    const sortTypeParameter = this.parseSortStateToSortTypeParameter(sortFeedModalCommentsBy);
    let selectedFeedId = this._getSelectedFeedId(index);
    this.props.actions.retrieveFeedDetails({
      sentiment,
      pageLimit: FEED_MODAL_ITEM_COUNT,
      pageId: 1,
      feedId: selectedFeedId,
      sortType: sortTypeParameter,
      minSarcasmScore: minimumSarcasmScoreDecimal,
      maxSarcasmScore: maximumSarcasmScoreDecimal
    });
    this.setState({
      isFeedModal: true,
      activeFeedCategory: sentiment,
      selectedFeedIndex: index,
      selectedFeedId: selectedFeedId,
      feedModalCurrentPage: 1
    });
    if (sentiment !== ALL){
      this.setState({
        groupFeedModalCommentsBy: GROUP_BY_SENTIMENT_STATE
      })
    }
  };

  _getSelectedFeedId(index) {
    let feedsToDisplay = this.returnFeedsToDisplay();
    return feedsToDisplay[DATA_KEY][index].feedId;
  }

  _parseSarcasmScorePercentageToDecimal = (sarcasmScore) => {
    let sarcasmScoreDecimal = sarcasmScore / 100;
    return sarcasmScoreDecimal.toFixed(MAXIMUM_DECIMAL_PLACES_FOR_SARCASM_SCORE);
  }

  parseSortStateToSortTypeParameter = sortType => {
    const sortTypeParameter = COMMENT_SORT_STATE_TO_VALUE_MAP[sortType];
    return sortTypeParameter;
  };

  loadMoreFeedDetails = () => {
    const { feedModalCurrentPage, 
            selectedFeedId, 
            sortFeedModalCommentsBy, 
            feedModalMinimumSarcasmScore, 
            feedModalMaximumSarcasmScore, 
            activeFeedCategory 
          } = this.state;
    const minimumSarcasmScoreDecimal = this._parseSarcasmScorePercentageToDecimal(feedModalMinimumSarcasmScore);
    const maximumSarcasmScoreDecimal = this._parseSarcasmScorePercentageToDecimal(feedModalMaximumSarcasmScore);
    const sortTypeParameter = this.parseSortStateToSortTypeParameter(sortFeedModalCommentsBy);
    const queryParams = {
      sentiment: activeFeedCategory,
      pageLimit: FEED_MODAL_ITEM_COUNT,
      pageId: Number(feedModalCurrentPage) + 1,
      feedId: selectedFeedId,
      sortType: sortTypeParameter,
      minSarcasmScore: minimumSarcasmScoreDecimal,
      maxSarcasmScore: maximumSarcasmScoreDecimal
    };
    this.setState(
      {
        feedModalCurrentPage: Number(feedModalCurrentPage) + 1,
      },
      () => {
        this.props.actions.retrieveFeedDetails(queryParams);
      },
    );
  };
  
  toggleChargedPostsFilter() {
    const { isChargedPostsFilterActive } = this.state;
    this.setState({ isChargedPostsFilterActive: !isChargedPostsFilterActive }, () => {this.filterFeeds();});
    
  }

  toggleEmotionallyHeatedFilter() {
    const { isEmotionallyHeatedFilterActive } = this.state;
    this.setState({ isEmotionallyHeatedFilterActive: !isEmotionallyHeatedFilterActive }, () => {this.filterFeeds();});
  }

  toggleToxicCommentsFilter() {
    const { isToxicCommentsFilterActive } = this.state;
    this.setState({ isToxicCommentsFilterActive: !isToxicCommentsFilterActive }, () => {this.filterFeeds();});
  }

  filterFeeds() {
    const { 
      isChargedPostsFilterActive,
      isEmotionallyHeatedFilterActive,
      isToxicCommentsFilterActive,
      feeds
    } = this.state;
    let filters = {
      isChargedPostsFilterActive: isChargedPostsFilterActive,
      isEmotionallyHeatedFilterActive: isEmotionallyHeatedFilterActive,
      isToxicCommentsFilterActive: isToxicCommentsFilterActive
    }
    let filterConditions = [
      this.filterChargedFeeds,
      this.filterFeedsWithHeatedComments,
      this.filterFeedsWithToxicComments
    ]
    let filteredFeeds = feeds.data.filter(feed => filterConditions.every(filterCondition => filterCondition(feed, filters)));
    this.setState({
      filteredFeeds: {
        data: filteredFeeds,
        count: filteredFeeds.length
      }
    });
  }

  filterChargedFeeds(feed, filters) {
    const { isChargedPostsFilterActive } = filters;
    if (!isChargedPostsFilterActive || (isChargedPostsFilterActive && feed.isChargedPost)) {
      return feed;
    }
  }

  filterFeedsWithHeatedComments(feed, filters) {
    const { isEmotionallyHeatedFilterActive } = filters;
    if (!isEmotionallyHeatedFilterActive || (isEmotionallyHeatedFilterActive && feed.percentageOfHeatedComments >= HEATED_COMMENTS_PERCENTAGE_THRESHOLD)) {
      return feed;
    }
  }

  filterFeedsWithToxicComments(feed, filters) {
    const { isToxicCommentsFilterActive } = filters;
    if (!isToxicCommentsFilterActive || (isToxicCommentsFilterActive && feed.percentageOfToxicComments >= TOXIC_COMMENTS_PERCENTAGE_THRESHOLD)) {
      return feed;
    }
  }

  handleCommentsGroupByInFeedModalChange(groupBySelection) {
    const groupBySelectionValue = groupBySelection[VALUE_KEY];
    if (groupBySelectionValue === GROUP_BY_SENTIMENT_STATE || groupBySelectionValue === GROUP_BY_EMOTION_STATE) {
      this.setState({groupFeedModalCommentsBy: groupBySelectionValue});
    }
  }

  retrieveSelectedSentimentFeedDetails(sentiment) {
    const { selectedFeedId, sortFeedModalCommentsBy, feedModalMinimumSarcasmScore, feedModalMaximumSarcasmScore } = this.state;
    const minimumSarcasmScoreDecimal = this._parseSarcasmScorePercentageToDecimal(feedModalMinimumSarcasmScore);
    const maximumSarcasmScoreDecimal = this._parseSarcasmScorePercentageToDecimal(feedModalMaximumSarcasmScore);
    const sortTypeParameter = this.parseSortStateToSortTypeParameter(sortFeedModalCommentsBy);
    const queryParams = {
      sentiment,
      pageLimit: FEED_MODAL_PAGE_LIMIT,
      pageId: 1,
      feedId: selectedFeedId,
      sortType: sortTypeParameter,
      minSarcasmScore: minimumSarcasmScoreDecimal,
      maxSarcasmScore: maximumSarcasmScoreDecimal
    };
    this.setState(
      {
        activeFeedCategory: sentiment,
        feedModalCurrentPage: 1,
      },
      () => {
        this.props.actions.retrieveFeedDetails(queryParams);
      },
    );
  };

  handleCommentsSortByInFeedModalChange(sortBySelection) {
    const sortBySelectionValue = sortBySelection[VALUE_KEY];
    if (COMMENT_SORT_OPTIONS.includes(sortBySelectionValue)){
      const sortTypeParameter = this.parseSortStateToSortTypeParameter(sortBySelectionValue);
      const { selectedFeedId, activeFeedCategory, feedModalMinimumSarcasmScore, feedModalMaximumSarcasmScore } = this.state;
      const minimumSarcasmScoreDecimal = this._parseSarcasmScorePercentageToDecimal(feedModalMinimumSarcasmScore);
      const maximumSarcasmScoreDecimal = this._parseSarcasmScorePercentageToDecimal(feedModalMaximumSarcasmScore);
      const queryParams = {
        sentiment: activeFeedCategory,
        pageLimit: FEED_MODAL_PAGE_LIMIT,
        pageId: 1,
        feedId: selectedFeedId,
        sortType: sortTypeParameter,
        minSarcasmScore: minimumSarcasmScoreDecimal,
        maxSarcasmScore: maximumSarcasmScoreDecimal
      };
      this.setState(
        {
          sortFeedModalCommentsBy: sortBySelectionValue,
          feedModalCurrentPage: 1
        },
        () => {
          this.props.actions.retrieveFeedDetails(queryParams);
        },
      );
    }
  };

  setFeedModalSarcasmScoreFilter(minimumSarcasmScore, maximumSarcasmScore) {
    if (minimumSarcasmScore === '') {
      minimumSarcasmScore = 0;
    }
    if (maximumSarcasmScore === '') {
      maximumSarcasmScore = 100;
    }
    this.retrieveFeedDetailsWithSarcasmScoreFilter(minimumSarcasmScore, maximumSarcasmScore);
  }

  retrieveFeedDetailsWithSarcasmScoreFilter (minimumSarcasmScore, maximumSarcasmScore) {
    const { activeFeedCategory, selectedFeedId, sortFeedModalCommentsBy } = this.state;
    const sortTypeParameter = this.parseSortStateToSortTypeParameter(sortFeedModalCommentsBy);
    const minimumSarcasmScoreDecimal = this._parseSarcasmScorePercentageToDecimal(minimumSarcasmScore);
    const maximumSarcasmScoreDecimal = this._parseSarcasmScorePercentageToDecimal(maximumSarcasmScore);

    const queryParams = {
      sentiment: activeFeedCategory,
      pageLimit: FEED_MODAL_PAGE_LIMIT,
      pageId: 1,
      feedId: selectedFeedId,
      sortType: sortTypeParameter,
      minSarcasmScore: minimumSarcasmScoreDecimal,
      maxSarcasmScore: maximumSarcasmScoreDecimal
    };
    this.setState(
      {
        feedModalCurrentPage: 1,
        feedModalMinimumSarcasmScore: minimumSarcasmScore,
        feedModalMaximumSarcasmScore: maximumSarcasmScore
      },
      () => {
        this.props.actions.retrieveFeedDetails(queryParams);
      },
    );
  };

  updateCrawledCommentIsSarcasmManuallyToggled(props) {
    this.setState({ isManuallyTogglingSarcasm: true });
    this.setCommentEmotionAndSentimentInfoToUseToUpdateChartsAfterSarcasmToggleSuccessful(props);
    this.callReduxActionToUpdateCrawledCommentIsSarcasmManuallyToggled(props);
  }

  setCommentEmotionAndSentimentInfoToUseToUpdateChartsAfterSarcasmToggleSuccessful(props) {
    let { emotionCategoriesBeforeTogglingComment, sentimentCategoriesBeforeTogglingComment } = this.state;
    emotionCategoriesBeforeTogglingComment[props.commentId] = props.emotionCategoryBeforeToggling;
    sentimentCategoriesBeforeTogglingComment[props.commentId] = props.sentimentCategoryBeforeToggling;
    this.setState({
      emotionCategoriesBeforeTogglingComment: emotionCategoriesBeforeTogglingComment,
      sentimentCategoriesBeforeTogglingComment: sentimentCategoriesBeforeTogglingComment
    });
  }

  callReduxActionToUpdateCrawledCommentIsSarcasmManuallyToggled(props) {
    const { updateCrawledCommentsIsSarcasmManuallyToggled } = this.props.actions;
    updateCrawledCommentsIsSarcasmManuallyToggled({commentId: props.commentId, isSarcasmManuallyToggled: props.isSarcasmManuallyToggled});
  }

  updateStateIfIsSarcasmManuallyToggledUpdated(newProps) {
    if (this.state.isManuallyTogglingSarcasm) {
      if (newProps.home.updateCrawledCommentsIsSarcasmManuallyToggledSuccess) {
        const commentAfterToggling = newProps.home.commentOrTweetAfterToggling;
        toast.success(SARCASM_LABEL_UPDATED_MESSAGE);
        this.setState({
          isManuallyTogglingSarcasm: false,
        });
        this.updatePostCountsAfterTogglingSarcasm(commentAfterToggling);
      }
      else if (newProps.home.updateCrawledCommentsIsSarcasmManuallyToggledFailure) {
        toast.error(SARCASM_LABEL_NOT_UPDATED_MESSAGE);
        this.setState({
          isManuallyTogglingSarcasm: false,
        });
      }
    }
  }

  updatePostCountsAfterTogglingSarcasm(commentAfterToggling) {
    if (!commentAfterToggling) {
      toast.error(SARCASM_POST_COUNT_UPDATE_ERROR_MESSAGE);
      return;
    }
    const commentId = commentAfterToggling.commentId;
    const { updatePostCountsForToggledSarcasticComment } = this.props.actions;
    const { emotionCategoriesBeforeTogglingComment, sentimentCategoriesBeforeTogglingComment } = this.state;
    const emotionCategoryBeforeTogglingComment = emotionCategoriesBeforeTogglingComment[commentId];
    const sentimentCategoryBeforeTogglingComment = sentimentCategoriesBeforeTogglingComment[commentId];
    if (commentAfterToggling.relevance) {
      updatePostCountsForToggledSarcasticComment(
        commentAfterToggling.feedId,
        commentAfterToggling,
        emotionCategoryBeforeTogglingComment,
        sentimentCategoryBeforeTogglingComment
      );
    }
  }

  returnFeedsToDisplay() {
    const { 
      feeds, 
      filteredFeeds,
      isChargedPostsFilterActive,
      isEmotionallyHeatedFilterActive,
      isToxicCommentsFilterActive
    } = this.state;
    if (isChargedPostsFilterActive || isEmotionallyHeatedFilterActive || isToxicCommentsFilterActive) {
      return filteredFeeds;
    }
    return feeds;
  }
  
  render() {

    const {
      isFeedsLoading,
      selectedFeedIndex,
      activeFeedCategory,
      isFeedModal,
      groupFeedModalCommentsBy,
      sortFeedModalCommentsBy,
      feedModalMinimumSarcasmScore,
      feedModalMaximumSarcasmScore,
      isChargedPostsFilterActive,
      isEmotionallyHeatedFilterActive,
      isToxicCommentsFilterActive
    } = this.state;

    const feedsToDisplay = this.returnFeedsToDisplay();

    let columnOneFeedIndices = [];
    let columnTwoFeedIndices = [];
    let columnThreeFeedIndices = [];
    for (let i =0;i<feedsToDisplay[DATA_KEY].length;i+=NUMBER_OF_COLUMNS_ON_HARM_WATCH_DASHBOARD) {
      columnOneFeedIndices.push(i);
    }
    for (let i =1;i<feedsToDisplay[DATA_KEY].length;i+=NUMBER_OF_COLUMNS_ON_HARM_WATCH_DASHBOARD) {
      columnTwoFeedIndices.push(i);
    }
    for (let i =2;i<feedsToDisplay[DATA_KEY].length;i+=NUMBER_OF_COLUMNS_ON_HARM_WATCH_DASHBOARD) {
      columnThreeFeedIndices.push(i);
    }

    return (
      <div>
        <div className="harm-watch-main-container">
          <div className="harm-watch-filter-row">
              <ImageButton 
                imageSrc={CHARGED_POST_ICON_FILE_PATH}
                label={CHARGED_POSTS_BUTTON_LABEL}
                onClick={() => this.toggleChargedPostsFilter()}
                inputClassName={isChargedPostsFilterActive ? IMAGE_BTN_SELECTED_CLASS : IMAGE_BTN_UNSELECTED_CLASS}
              />
              <ImageButton 
                imageSrc={HEATED_COMMENTS_ICON_FILE_PATH}
                label={HEATED_COMMENTS_BUTTON_LABEL}
                onClick={() => this.toggleEmotionallyHeatedFilter()}
                inputClassName={isEmotionallyHeatedFilterActive ? IMAGE_BTN_SELECTED_CLASS : IMAGE_BTN_UNSELECTED_CLASS}
              />
              <ImageButton 
                imageSrc={TOXIC_COMMENTS_ICON_FILE_PATH}
                label={TOXIC_COMMENTS_BUTTON_LABEL}
                onClick={() => this.toggleToxicCommentsFilter()}
                inputClassName={isToxicCommentsFilterActive ? IMAGE_BTN_SELECTED_CLASS : IMAGE_BTN_UNSELECTED_CLASS}
              />
              <Button 
                icon="download" 
                label={EXPORT_BUTTON_LABEL} 
                onClick={() => {}} 
              />
          </div>
          
          <div className="row justify-content-center harm-watch-feeds">
            <div className="col-4">
              <div className="row">
                {columnOneFeedIndices.map((index) => (
                  <HarmWatchFeed 
                    feed={feedsToDisplay[DATA_KEY][index]} 
                    key={feedsToDisplay[DATA_KEY][index].feedId}
                    handleFeedDetails={e => this.handleFeedDetails(e, index)} 
                  />
                ))}
              </div>
            </div>
            <div className="col-4">
              <div className="row">
                {columnTwoFeedIndices.map((index) => (
                  <HarmWatchFeed 
                    feed={feedsToDisplay[DATA_KEY][index]} 
                    key={feedsToDisplay[DATA_KEY][index].feedId} 
                    handleFeedDetails={e => this.handleFeedDetails(e, index)} 
                  />
                ))}
              </div>
            </div>
            <div className="col-4">
              <div className="row">
                {columnThreeFeedIndices.map((index) => (
                  <HarmWatchFeed 
                    feed={feedsToDisplay[DATA_KEY][index]} 
                    key={feedsToDisplay[DATA_KEY][index].feedId} 
                    handleFeedDetails={e => this.handleFeedDetails(e, index)} 
                  />
                ))}
              </div>
            </div>
          </div>
        </div>
        {feedsToDisplay[COUNT] && feedsToDisplay[COUNT] > feedsToDisplay[DATA_KEY].length && (
            <button
              type="button"
              className={`btn btn-loadmore ${isFeedsLoading ? 'disabled' : ''}`}
              onClick={() => this.loadMoreFeeds()}
            >
              {isFeedsLoading ? (
                <React.Fragment>
                  <i className="la la-spinner la-spin" /> Loading
                </React.Fragment>
              ) : (
                'LOAD MORE'
              )}
            </button>
          )}
        {isFeedModal && (
          <FeedDetails
            show={isFeedModal}
            toggleFeedDetails={() => this.setState({ isFeedModal: false })}
            feed={feedsToDisplay[DATA_KEY] ? feedsToDisplay[DATA_KEY][selectedFeedIndex] : []}
            feedDetails={this.props.home.feedDetails}
            loadMoreFeedDetails={() => this.loadMoreFeedDetails()}
            activeFeedCategory={activeFeedCategory}
            groupFeedModalCommentsBy={groupFeedModalCommentsBy}
            sortFeedModalCommentsBy={sortFeedModalCommentsBy}
            feedModalMinimumSarcasmScore={feedModalMinimumSarcasmScore}
            feedModalMaximumSarcasmScore={feedModalMaximumSarcasmScore}
            isHarmWatchTab={true}
            handleCommentsGroupByInFeedModalChange={e => this.handleCommentsGroupByInFeedModalChange(e)}
            retrieveSelectedSentimentFeedDetails={e => this.retrieveSelectedSentimentFeedDetails(e)}
            handleCommentsSortByInFeedModalChange={e => this.handleCommentsSortByInFeedModalChange(e)}
            setFeedModalSarcasmScoreFilter={(e,f) => this.setFeedModalSarcasmScoreFilter(e,f)}
            updateCrawledCommentsIsSarcasmManuallyToggled={(e) => this.updateCrawledCommentIsSarcasmManuallyToggled(e)}
          />
        )}
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    home: state.home
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(HarmWatch);



// WEBPACK FOOTER //
// ./src/features/harmwatch/HarmWatch.js